import * as React from 'react';
export const UZSvg = React.forwardRef(function UZSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          transform: 'translate(0 2)',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#217AB7',
          d: 'M1.994 0h12.012C15.106 0 16 .895 16 2v2H0V2C0 .888.893 0 1.994 0Z',
        }),
        /*#__PURE__*/ React.createElement('circle', {
          cx: 3,
          cy: 2,
          r: 1,
          fill: '#FFF',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#F6F9FC',
          fillRule: 'nonzero',
          d: 'M0 4h16v4H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#EAEEF3',
          fillRule: 'nonzero',
          d: 'M15 8V4h1v4h-1ZM0 4h1v4H0V4Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#24B47E',
          d: 'M0 8h16v2c0 1.112-.893 2-1.994 2H1.994C.894 12 0 11.105 0 10V8Z',
        }),
      ),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 6h16v1H0zm0 3h16v1H0z',
      }),
    ),
  );
});
UZSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var UZ = {
  category: 'flag',
  colorable: false,
  name: 'UZ',
  svg: UZSvg,
};
